// @owners { team: patients }
import { type ReduxStateShared } from '~shared/types';
import { type QuantityOption } from '~shared/types/clients';

const getQuantityOptionsByPrescriptionID = (state: ReduxStateShared, prescriptionID: number): QuantityOption[] => {
  return state.quantityOptions[prescriptionID] || [];
};

export default getQuantityOptionsByPrescriptionID;
